import { CheckCircleIcon } from '@chakra-ui/icons'
import { Box, Flex, Text } from '@chakra-ui/react'

type IndexItemProps = {
  index: number
  title: string | JSX.Element
  done: boolean
  current: boolean
  id: string
  noIndexNumber?: boolean
}
const TodoIndexItem: React.VFC<
  IndexItemProps & { setCurrentEditingTaskIndex: (index: number) => void }
> = ({
  index,
  title,
  current,
  done,
  id,
  noIndexNumber,
  setCurrentEditingTaskIndex
}) => {
  return (
    <Flex
      py="20px"
      px="16px"
      gap="8px"
      align="center"
      cursor="pointer"
      bgColor={current ? 'gray.70' : 'initial'}
      onClick={() => {
        setCurrentEditingTaskIndex(index)
        setTimeout(() => {
          document
            .getElementById(id)
            ?.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 200)
      }}
    >
      {done ? (
        <CheckCircleIcon w="20px" h="20px" color="primary.purple" />
      ) : (
        !noIndexNumber && (
          <Text
            bgColor={!done && !current ? 'gray.400' : 'primary.black'}
            w="20px"
            h="20px"
            color="white"
            borderRadius="full"
            lineHeight="20px"
            fontWeight={700}
            fontSize="12px"
            textAlign="center"
          >
            {index + 1}
          </Text>
        )
      )}
      <Text
        lineHeight="16px"
        fontWeight={current ? 700 : 500}
        fontSize="16px"
        color={!done && !current ? 'gray.400' : 'primary.black'}
      >
        {title}
      </Text>
    </Flex>
  )
}

export type TodoIndexProps = {
  indexes: Array<Omit<IndexItemProps, 'index'>>
  noIndexNumber?: boolean
  setCurrentEditingTaskIndex: (index: number) => void
}
export const TodoIndex: React.VFC<TodoIndexProps> = ({
  indexes,
  noIndexNumber,
  setCurrentEditingTaskIndex
}) => {
  return (
    <Box pt="108px" w="220px" pos="absolute">
      {indexes.map((index, i) => (
        <TodoIndexItem
          key={i}
          {...index}
          noIndexNumber={noIndexNumber}
          index={i}
          setCurrentEditingTaskIndex={setCurrentEditingTaskIndex}
        />
      ))}
    </Box>
  )
}
